import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as commonActions from '../common/redux/actions';
import CollectionHeaderNav from './CollectionHeaderNav';
import CustomLoader from '../common/CustomLoader';
import types from '../../common/formElements/CollectionSectionType';
import { drapcodeIcon, iconForField } from '../../common/custom/icon-library';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import CustomSelect from '../home/collections/CustomSelect';
import { ListDerivedFieldMappings } from './collection/derived-field/ListDerivedFieldMappings';
import { isProjectReadOnly } from '../../common/utils/api_utils';

export class DerivedFieldMapping extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    commonActions: PropTypes.object.isRequired,
  };

  state = {
    targetCollectionFields: [{ value: '', key: '' }],
    referenceFields: [],
    referenceCollectionFields: [{ value: '', key: '' }],
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { params } = match;
    const { projectId, collectionId, version } = params;
    const { loadProjectCollectionDetail, loadProjectCollections } = actions;
    loadProjectCollectionDetail({ projectId, collectionId, version });
    loadProjectCollections({ projectId, version });
  }

  handleSubmit = async (values, setSubmitting, resetForm) => {
    const { collections, match, actions, commonActions } = this.props;
    const { projectId, version } = match.params;
    const { selectedCollection } = collections;
    setSubmitting(true);
    const derivedFieldMapping = Object.entries(values)
      .filter(([key, val]) => key !== 'mappingName' && val && typeof val === 'object' && val.value)
      .map(([fieldName, val]) => ({
        fieldName,
        derivedField: val.value,
      }));
    const data = {
      mappingName: values.mappingName,
      derivedFieldMapping,
    };
    try {
      await actions.createDerivedFieldMappingInCollection({
        projectId,
        version,
        data,
        selectedCollection,
      });
      commonActions.trackCollectionChange({
        uuid: selectedCollection.uuid,
        name: selectedCollection.collectionName,
      });
      resetForm();
    } catch (error) {
      console.error('Error in creating mapping:', error);
    } finally {
      setSubmitting(false);
    }
  };

  render() {
    const { collections, match, actions, commonActions } = this.props;
    const { projectId, version } = match.params;
    const { loadProjectCollectionDetailPending, selectedCollection } = collections;
    const derivedFieldOptions =
      selectedCollection && selectedCollection.utilities.length
        ? selectedCollection.utilities.map((derivedField) => ({
            value: derivedField,
            label: derivedField.name,
          }))
        : [];
    const isReadOnly = isProjectReadOnly(projectId);
    return (
      <div className="main collections-mapping">
        <div className="section">
          <div className="container">
            <CollectionHeaderNav
              label={types.DERIVED_FIELD_MAPPING}
              projectId={projectId}
              version={version}
              selectedCollection={selectedCollection}
              loadProjectCollectionDetailPending={loadProjectCollectionDetailPending}
            />
            {loadProjectCollectionDetailPending && (
              <div className="text-center">
                <CustomLoader
                  loading={loadProjectCollectionDetailPending}
                  size="20px"
                  color="#303453"
                />
              </div>
            )}
            {selectedCollection && (
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                <div className="row mx-auto">
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                    <div className="card">
                      <div
                        className="card-header card-header-icon"
                        data-background-color="drapcode-dark-blue"
                      >
                        <i className={`wb ${drapcodeIcon('derivedFields')}`}></i>
                      </div>
                      <div className="card-content">
                        <h5 className="card-title mb-0 pb-0">
                          Add Derived Field Mapping{' '}
                          {typeof selectedCollection !== 'undefined' && selectedCollection
                            ? ' To ' + selectedCollection.collectionTitle
                            : ''}
                        </h5>
                        <p>
                          Add mapping to ensure the derived field data is correctly displayed in
                          this field.
                        </p>
                        <Formik
                          initialValues={{
                            mappingName: '',
                            derivedFieldMapping: {},
                          }}
                          onSubmit={(values, { setSubmitting, resetForm }) => {
                            !isReadOnly && this.handleSubmit(values, setSubmitting, resetForm);
                          }}
                        >
                          {({ values, setFieldValue, setFieldTouched }) => (
                            <Form className="form-horizontal">
                              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                <div className="form-group">
                                  <div className="input-group">
                                    <div className="input-group-prepend" title="Mapping Name">
                                      <span className="input-group-text">
                                        <i className={`wb ${iconForField('text')}`}></i>
                                        <span className="required"> *</span>
                                      </span>
                                    </div>
                                    <Field
                                      type="text"
                                      name="mappingName"
                                      className="form-control form-control-sm"
                                      placeholder="Name of Derived Field Mapping"
                                    />
                                    <ErrorMessage name="mappingName">
                                      {(msg) => <p className="text-error">{msg}</p>}
                                    </ErrorMessage>
                                  </div>
                                </div>
                              </div>
                              <div className="row font-weight-bold mb-3">
                                <div className="col">
                                  <h5>Collection Field ({selectedCollection.fields.length})</h5>
                                </div>
                                <div className="col">
                                  <h5>Derived Field</h5>
                                </div>
                              </div>
                              {selectedCollection.fields.map((field) => (
                                <div className="row mx-auto mb-3" key={field.fieldName}>
                                  <div className="col-md col-lg col-sm-12 col-xs-12">
                                    <span className="input-group-text">{field.fieldTitle.en}</span>
                                  </div>
                                  <div className="col-md col-lg col-sm-12 col-xs-12">
                                    <CustomSelect
                                      name={field.fieldName}
                                      isMulti={false}
                                      value={values[field.fieldName]}
                                      options={derivedFieldOptions}
                                      onChange={setFieldValue}
                                      onBlur={setFieldTouched}
                                      placeholder="Select Derived Field"
                                    />
                                  </div>
                                </div>
                              ))}
                              <div className="text-right mt-3">
                                <button
                                  type="submit"
                                  className="btn btn-theme-submit btn-md"
                                  disabled={isReadOnly}
                                  title={isReadOnly && 'Read-Only Mode'}
                                >
                                  <i className="wb webconnect-plus"></i>&nbsp;Save&nbsp;
                                  <CustomLoader loading={false} />
                                </button>
                              </div>
                            </Form>
                          )}
                        </Formik>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                    <div className="card">
                      <div
                        className="card-header card-header-icon"
                        data-background-color="drapcode-dark-blue"
                      >
                        <i className={`wb ${drapcodeIcon('list')}`}></i>
                      </div>
                      <div className="card-content">
                        <h5 className="card-title">Derived Field Mapping</h5>
                        <ListDerivedFieldMappings
                          collections={collections}
                          actions={actions}
                          commonActions={commonActions}
                          projectId={projectId}
                          version={version}
                          isReadOnly={isReadOnly}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    commonActions: bindActionCreators({ ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DerivedFieldMapping);
